module.exports = __webpack_public_path__ + "a64ec1911cebe554bdc30c4a0e740530.png";